import Swal from "sweetalert2";
import Success from "./Typography/Success";
import Danger from "./Typography/Danger";
import React from "react";
import {infoColor, primaryColor} from "../assets/jss/material-dashboard-pro-react";
import {WebService} from "./WebService";

export function zeroEsquerda(numero, casas = 2) {
  numero = parseInt(numero || 0, 10);
  casas = (casas - 1);
  if (numero < Math.pow(10, casas)) {
    numero = new Array(casas).fill("0").join("") + numero;
  }
  return numero.toString();
}

export function pontuacaoNumero(valor) {
  let valorFinal = "";
  valor = (valor || "0").toString().split("").reverse().join("");
  for (let i = valor.length - 1; i >= 0; i--) {
    valorFinal += valor[i];

    if (((i % 3) === 0) && (i > 0)) {
      valorFinal += ".";
    }
  }
  return valorFinal;
}

export const somenteNumero = numero => numero.toString().split("").filter(el => !isNaN(parseInt(el))).join("");

export function nomeProprio(nome) {
  if (!nome)
    return "";
  nome = nome.toLowerCase().split(" ");
  for (let i = 0; i < nome.length; i++) {
    if (nome[i].length > 3 || i === 0)
      nome[i] = nome[i][0].toUpperCase() + nome[i].slice(1).toLowerCase();
  }
  nome = nome.join(" ");
  return nome;
}

export function formatoDinheiro(valor) {
  const sinalDinheiro = "R$";
  if (!valor && valor !== 0) return `${sinalDinheiro} 0,00`;
  valor = parseFloat(valor).toFixed(2).toString().split(".");
  return `${sinalDinheiro} ${pontuacaoNumero(valor[0]) + "," + valor[1]}`;
}

/**
 * @return {boolean}
 */
function validaCPF(cpf) {
  cpf = somenteNumero(cpf);
  let soma = 0;
  let resto;
  if (cpf === "00000000000") return false;

  for (let i = 1; i <= 9; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;

  if ((resto === 10) || (resto === 11)) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10))) return false;

  soma = 0;
  for (let i = 1; i <= 10; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;

  if ((resto === 10) || (resto === 11)) resto = 0;
  return !(resto !== parseInt(cpf.substring(10, 11)));
}

export const validacoes = {
  nome: nome => nome ? nome.trim().split(" ").length > 1 : false,
  email: email => (/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/.test(email)),
  whatsapp: async whatsapp => (await (await fetch(`https://api.comunicacao.nervusw.com.br/v1/whatsapp_api/getDadosContato?numero=${whatsapp}`)).json()).ok,
  cpf: validaCPF,
  cartaoCVV: cvv => ([3, 4].indexOf(cvv.toString().length) > -1),
  cartaoNumero: numero => (somenteNumero(numero).length >= 13)
};

export const buscarEnderecoCEP = async cep => {
  Swal.fire({title: 'Buscando endereço.', allowOutsideClick: false, showConfirmButton: false});
  Swal.showLoading();
  try {
    const baseURL = `https://api.pagar.me/1/zipcodes/`;
    const {errors, zipcode, street, neighborhood, city, state} = await (await fetch(`${baseURL}${cep}`)).json();
    Swal.close();
    Swal.close();
    return {errors, zipcode, street, neighborhood, city, state};
  } catch (e) {
    Swal.close();
  }
};

export const getBandeiraCartaoImagem = bandeira => {
  bandeira = bandeira === "amex" ? "americanexpress" : bandeira;
  const baseURL = `https://app.myfinance.com.br/assets/logos/logo-creditcard`;
  return bandeira && (bandeira !== "unknown") && `${baseURL}-${bandeira}.png`;
};

export const dadosInputsCartao = {
  meses: [
    {label: "MM", disabled: true, selected: true},
    ...new Array(12).fill(null).map((prop, key) => {
      const valor = key + 1;
      return {label: zeroEsquerda(valor), value: valor};
    })
  ],
  anos: [
    {label: "ANO", disabled: true, selected: true},
    ...new Array(20).fill(null).map((prop, key) => {
      const valor = key + new Date().getFullYear();
      return {label: valor, value: valor};
    })
  ],
  parcelas: (valor, totalParcelas = 12, taxas = []) => {
    return new Array(totalParcelas).fill(null).map((prop, key) => {
      const parcela = key + 1;
      const taxa = (taxas[key] || 0) / 100 * valor;
      return {
        label: `${parcela}x de ${formatoDinheiro((valor + taxa) / parcela)}`,
        value: parcela
      };
    })
  }
};

export const copyToClipboard = text => {
  const textField = document.createElement('textarea');
  textField.innerText = text;
  document.body.appendChild(textField);
  textField.select();
  document.execCommand('copy');
  textField.remove();
};

export const ls = (slug, defaultValue = "") => localStorage.getItem(slug) || defaultValue;

export const buscarDadosCNPJ = async (cnpj, loading = true, mostrarErro = true) => {
  const cnpjLimpo = (cnpj || "").toString().replace(/\D/g, "");

  if (cnpjLimpo.length !== 14) {
    const mensagem_usuario = "CNPJ inválido.";
    const descricao_usuario = "Informe um CNPJ com 14 dígitos.";
    if (mostrarErro) {
      await Swal.fire({icon: "warning", title: mensagem_usuario, text: descricao_usuario});
    }
    return {ok: false, empresa: null, mensagem_usuario, descricao_usuario};
  }

  if (loading) {
    Swal.fire({title: 'Buscando dados CNPJ', icon: 'info', allowOutsideClick: false, showConfirmButton: false});
    Swal.showLoading();
  }

  try {
    const resp = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${cnpjLimpo}`);
    let data = {};
    try {
      data = await resp.json();
    } catch (e) {
      data = {};
    }

    if (loading) await Swal.close();

    if (resp.ok) {
      return {ok: true, empresa: data};
    }

    const mensagem_usuario = "Dados automáticos da empresa não encontrados.";
    const descricao_usuario = data.message || data.mensagem || `Falha ao consultar CNPJ ${cnpjLimpo}.`;

    if (mostrarErro) {
      await Swal.fire({icon: "warning", title: mensagem_usuario, text: descricao_usuario});
    }

    return {ok: false, empresa: null, mensagem_usuario, descricao_usuario, raw: data};
  } catch (e) {
    if (loading) await Swal.close();

    const mensagem_usuario = "Dados automáticos da empresa não encontrados.";
    const descricao_usuario = (e && e.toString && e.toString()) || "Erro desconhecido ao consultar CNPJ.";

    if (mostrarErro) {
      await Swal.fire({icon: "warning", title: mensagem_usuario, text: descricao_usuario});
    }

    return {ok: false, empresa: null, mensagem_usuario, descricao_usuario};
  }
};

export const dataHumano = (inputData) => {
  if (inputData === "" || !inputData) return "";
  return convertDate(inputData, false, true);
};

export function convertDate(inputFormat, sqlformat = false, datetime = false, onlyTime = false) {
  if (inputFormat === "" || !inputFormat)
    return "";

  function pad(s) {
    return (s < 10) ? '0' + s : s;
  }

  var d = new Date(inputFormat);
  var time = "";
  if (datetime || onlyTime)
    time = " " + [pad(d.getHours()), pad(d.getMinutes())].join(":");
  if (onlyTime)
    return time;
  if (sqlformat)
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-') + time;
  else
    return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/') + time;
}

export const fetchAsBlob = url => fetch(url)
  .then(response => response.blob());

export const convertBlobToBase64 = blob => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onerror = reject;
  reader.onload = () => {
    resolve(reader.result);
  };
  reader.readAsDataURL(blob);
});

export const isValidDate = d => d instanceof Date && !isNaN(d);

export const undefinedFunction = a => a;

export const downloadFileAsBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const formataCPFCNPJ = valor => {
  if (!valor)
    return "";
  valor = somenteNumero(valor).toString();
  if (valor.length === 11)
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
  else if (valor.length === 14)
    return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5");
  return valor;
};


export const getColoredNumber = (number, invertido = false) => {
  number = parseInt(number);
  const Component = invertido ? Danger : Success;
  const ComponentNegativo = invertido ? Success : Danger;

  if (number > 0)
    return <Component><strong>{number}</strong></Component>;
  if (number < 0)
    return <ComponentNegativo><strong>{number}</strong></ComponentNegativo>;
  return number;
};

export const sairSistema = () => {
  const tokenAtual = ls('tokenAtual');
  localStorage.removeItem('token');
  localStorage.removeItem('tokenAtual');
  if (tokenAtual)
    localStorage.setItem('token', tokenAtual);
  window.location.reload();
};

export const Filter = ({filter, onChange}, fn = a => a) => {
  if (typeof fn !== "function")
    fn = a => a;

  return (
    <input
      onChange={({target}) => onChange(fn(target.value))}
      value={filter ? filter.value : ''}
      placeholder={"Pesquisar"}
      style={{
        width: '100%',
        backgroundImage: `linear-gradient(${infoColor[0]}, ${infoColor[4]}), linear-gradient(#d2d2d2, #d2d2d2)`
      }}
    />
  );
};

export const FilterSelect = ({filter, onChange}, fn = a => a, opcoes = []) => {
  if (typeof fn !== "function")
    fn = a => a;

  return (
    <select
      onChange={({target}) => onChange(fn(target.value))}
      style={{
        width: '100%',
        color: '#555',
        fontSize: 14,
        padding: '5px 0',
        backgroundImage: `linear-gradient(${infoColor[0]}, ${infoColor[4]}), linear-gradient(#d2d2d2, #d2d2d2)`
      }}
    >
      {opcoes.map((prop, key) => (
        <option value={prop} key={key}>
          {nomeProprio(prop)}
        </option>
      ))}
    </select>
  );

  return (
    <input
      onChange={({target}) => onChange(fn(target.value))}
      value={filter ? filter.value : ''}
      placeholder={"Pesquisar"}
      style={{
        width: '100%',
        backgroundImage: `linear-gradient(${infoColor[0]}, ${infoColor[4]}), linear-gradient(#d2d2d2, #d2d2d2)`
      }}
    />
  );
};

export const alterarSenhaUsuario = async (outros = {}, validado = true) => {
  do {
    const {value: senha} = await Swal.fire({
      title: 'Nova Senha',
      input: 'password',
      inputPlaceholder: 'Nova Senha',
      inputAttributes: {maxlength: 20, autocapitalize: 'off', autocorrect: 'off'}
    });

    if (senha) {
      const {value: passwordConfirm} = await Swal.fire({
        title: 'Confirme a nova Senha',
        input: 'password',
        inputPlaceholder: 'Confirme a nova Senha',
        inputAttributes: {maxlength: 20, autocapitalize: 'off', autocorrect: 'off'}
      });
      if (senha.length >= 6) {
        if (senha === passwordConfirm) {
          const {ok} = await WebService("/usuario/alterarSenha", {senha, ...outros}, "POST");
          if (ok) {
            await Swal.fire({icon: "success", title: "Senha alterada com sucesso!"});
            validado = true;
          }
        } else
          await Swal.fire({icon: "warning", title: "As senhas não correspondem."});
      } else
        await Swal.fire({icon: "warning", title: "As senhas devem conter no mínimo 6 caracteres."});
    } else
      await Swal.fire({icon: "warning", title: "A senha não é válida."});
  } while (!validado);
};

export const tiposNotas = {55: 'NF-e', 57: 'CT-e', 65: 'NFC-e', 99: 'NFS-e'};

export const convertToSlug = (text) => {
  const a = 'àáäâãèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;';
  const b = 'aaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------';
  const p = new RegExp(a.split('').join('|'), 'g');
  return text.toString().toLowerCase().trim()
    .replace(p, c => b.charAt(a.indexOf(c)))
    .replace(/&/g, '-and-')
    .replace(/[\s\W-]+/g, '_');
}

export const getDistinctFromArray = array => {
  const newArray = [];
  array.forEach(prop => newArray.indexOf(prop) === -1 && newArray.push(prop));
  return newArray;
};

export const getChildrenComponentText = (component) => {
  if (component || parseInt(component) === 0) {
    if (["string", "number"].indexOf(typeof component) !== -1) {
      return component;
    } else if (typeof component === "object") {
      const {props} = component;
      if (props) {
        const {children} = props;
        if (children)
          return getChildrenComponentText(children);
      }
    }
  }
};

export const filtrarDados = (dados, filtro) => {
  if(!filtro) return dados;
  let tempRegistros = [];
  for (let i = 0; i < dados.length; i++) {
    const keys = Object.keys(dados[i]);
    for (let j = 0; j < keys.length; j++) {
      const valor = getChildrenComponentText(dados[i][keys[j]]);
      if ((valor || "").toString().toLowerCase().indexOf(filtro) > -1)
        tempRegistros.push(i);
    }
  }

  return tempRegistros.filter((este, i) => tempRegistros.indexOf(este) === i).map(prop => dados[prop]);
}

export const imprimirTabela = ({titlePrint, colunas, dados, printOrder}) => {
  // let modeloTabela = "<style></style>";
  let modeloTabela = `<style>td{border: 1px solid ${primaryColor[6]};}body{background-color:#91ced4}body *{box-sizing:border-box}.header{background-color:${primaryColor[0]};color:#fff;font-size:1.5em;padding:1rem;text-align:center;text-transform:uppercase}img{border-radius:50%;height:60px;width:60px}.table-users{border:1px solid ${primaryColor[4]};border-radius:10px;box-shadow:3px 3px 0 rgba(0,0,0,.1);max-width:calc(100% - 2em);margin:1em auto;overflow:hidden;width:800px}table{width:100%}table td,table th{color:#2b686e;padding:10px}table td{text-align:center;vertical-align:middle}table td:last-child{font-size:.95em;line-height:1.4;text-align:left}table th{background-color:#daeff1;font-weight:300}table tr:nth-child(2n){background-color:#fff}table tr:nth-child(2n+1){background-color:#edf7f8}@media screen and (max-width:700px){table,td,tr{display:block}td:first-child{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:100px}td:not(:first-child){clear:both;margin-left:100px;padding:4px 20px 4px 90px;position:relative;text-align:left}td:not(:first-child):before{color:#91ced4;content:'';display:block;left:0;position:absolute}td:nth-child(2):before{content:'Name:'}td:nth-child(3):before{content:'Email:'}td:nth-child(4):before{content:'Phone:'}td:nth-child(5):before{content:'Comments:'}tr{padding:10px 0;position:relative}tr:first-child{display:none}}@media screen and (max-width:500px){.header{background-color:transparent;color:#fff;font-size:2em;font-weight:700;padding:0;text-shadow:2px 2px 0 rgba(0,0,0,.1)}img{border:3px solid;border-color:#daeff1;height:100px;margin:.5rem 0;width:100px}td:first-child{background-color:#c8e7ea;border-bottom:1px solid #91ced4;border-radius:10px 10px 0 0;position:relative;top:0;-webkit-transform:translateY(0);transform:translateY(0);width:100%}td:not(:first-child){margin:0;padding:5px 1em;width:100%}td:not(:first-child):before{font-size:.8em;padding-top:.3em;position:relative}td:last-child{padding-bottom:1rem!important}tr{background-color:#fff!important;border:1px solid #6cbec6;border-radius:10px;box-shadow:2px 2px 0 rgba(0,0,0,.1);margin:.5rem 0;padding:0}.table-users{border:none;box-shadow:none;overflow:visible}}</style>`;
  modeloTabela += `<style>tr {page-break-inside: avoid !important;}</style>`;
  modeloTabela += `<title>${titlePrint || ':: Relatório Gefis ::'}</title>`;
  const contrato = window.open('', '', 'height=595,width=841');

  modeloTabela += "<table style='width: 100%'>";
  modeloTabela += "    <tr>";
  colunas.map(prop => {
    modeloTabela += "<th>";
    modeloTabela += `    <Span color={"${primaryColor[0]}"}>${prop}</Span>`;
    modeloTabela += "</th>";
    return null;
  });

  dados.map(prop => {
    modeloTabela += `<tr>`;
    prop.map(prop1 => {
      modeloTabela += `<td style="text-align: center">`;
      if (prop1) {
        const {impressao} = prop1;
        if (impressao)
          prop1 = impressao;
      }
      const componente = getChildrenComponentText(prop1);
      modeloTabela += parseInt(componente) === 0 ? "0" : (componente || "");
      modeloTabela += `</td>`;
      return null;
    });
    modeloTabela += `</tr>`;
    return null;
  });

  modeloTabela += "    </tr>";
  modeloTabela += "</table>";

  contrato.document.write(modeloTabela);
  contrato.document.close();
  contrato.print();
}

export const estadosUF = {
  RO: 11, AC: 12, AM: 13, RR: 14, PA: 15, AP: 16, TO: 17, MA: 21, PI: 22, CE: 23, RN: 24, PB: 25, PE: 26,
  AL: 27, SE: 28, BA: 29, MG: 31, ES: 32, RJ: 33, SP: 35, PR: 41, SC: 42, RS: 43, MS: 50, MT: 51, GO: 52,
  DF: 53
};
